module.exports = __webpack_public_path__ + "/build/web/images/lookbook@2x.7a2d63357e1d41aa9c8f05d140539307.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/lookbook@2x.jpg
// module id = 167
// module chunks = 13